import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnalyticsFilters } from '@brand-lolly/app/social-media-influencer/modules/social-listening/models/social-listening-analytics.model';
import { advancedPostToQuery } from '@brand-lolly/app/social-media-influencer/modules/social-listening/components/advanced-filters/advanced-filters.types';
import { SlMatchTypeFilter } from '@brand-lolly/app/social-media-influencer/modules/social-listening/components/filters/match-type/match-type.component';
import { recoverUnlessStrict } from '@brand-lolly/app/social-media-influencer/modules/social-listening/services/recover-unless-strict';
import { smiUrl } from 'components';
import { map, Observable } from 'rxjs';

export interface EmotionDistribution {
	love: number;
	joy: number;
	surprise: number;
	anger: number;
	sadness: number;
	fear: number;
	disgust: number;
}

interface EmotionDistributionApi {
	love: number;
	joy: number;
	surprise: number;
	anger: number;
	sadness: number;
	fear: number;
	disgust: number;
}

@Injectable({
	providedIn: 'root'
})
export class GetSocialListeningMyBrandAnalyticsEmotionDistributionService {
	constructor(private http: HttpClient) {}

	fetch(
		brandId: string,
		cutoff?: Date | null,
		filters?: AnalyticsFilters,
		to?: Date | null,
		matchType?: SlMatchTypeFilter,
		strict = false
	): Observable<EmotionDistribution> {
		const urlBuilder = smiUrl()
			.add('social-listening')
			.add('brand')
			.add(brandId)
			.add('analytics-emotion-distribution');

		if (cutoff) {
			urlBuilder.query('from', cutoff.toISOString());
		}
		if (to) {
			urlBuilder.query('to', to.toISOString());
		}
		this.applyFilters(urlBuilder, filters, matchType);

		const url = urlBuilder.done();

		return this.http.get<EmotionDistributionApi>(url).pipe(
			recoverUnlessStrict(
				strict,
				(): EmotionDistributionApi => ({
					love: 0,
					joy: 0,
					surprise: 0,
					anger: 0,
					sadness: 0,
					fear: 0,
					disgust: 0
				})
			),
			map(r => ({
				love: r.love,
				joy: r.joy,
				surprise: r.surprise,
				anger: r.anger,
				sadness: r.sadness,
				fear: r.fear,
				disgust: r.disgust
			}))
		);
	}

	private applyFilters(
		b: any,
		filters?: AnalyticsFilters,
		matchType?: SlMatchTypeFilter
	): void {
		if (filters?.platforms?.length)
			b.query('platforms', filters.platforms.join(','));
		if (filters?.sentiments?.length)
			b.query('sentiments', filters.sentiments.join(','));
		if (filters?.emotions?.length)
			b.query('emotions', filters.emotions.join(','));
		if (filters?.languages?.length)
			b.query('languages', filters.languages.join(','));
		if (filters?.engagementRate) {
			b.query('engagement_rate_min', String(filters.engagementRate[0]));
			b.query('engagement_rate_max', String(filters.engagementRate[1]));
		}
		if (matchType) b.query('match_type', matchType);
		for (const [advKey, advVal] of Object.entries(
			advancedPostToQuery(filters?.advanced)
		)) {
			b.query(advKey, advVal);
		}
	}
}
